import { useQuery } from '@apollo/client'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { GET_CATEGORIES } from '../services/graphql/queries/getCategories'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Layout from '../components/layouts/AppLayout'
import Head from 'next/head'
import { useRouter } from 'next/router'
import useTranslatedRoutes from '../services/translatedRoutes'
import { useMemo } from 'react'

export default function Categories () {
  const { data } = useQuery(GET_CATEGORIES, {
    variables: {
      active_only: true
    }
  })
  const { t } = useTranslation(['categories', 'home'])
  const router = useRouter()
  const language = router.locale.toUpperCase()
  const { getCategoryUrl } = useTranslatedRoutes(language)
  const sortedCategories = useMemo(() => {
    if (!data) {
      return []
    }

    return [...data.categories]
      .map(category => {
        const newCategory = { ...category }

        newCategory.translatedName = t(category.name)

        return newCategory
      })
      .sort((a, b) => a.translatedName.localeCompare(b.translatedName))
  })

  return (
    <Layout variant="white">
      <Head>
        <title>{t('categories.title', { ns: 'home' })}</title>
      </Head>
      <div className="container">
        <div className="row px-2">
          <div className="col-12">
            <h1 className="text-dark mb-4 mt-md-4 mb-md-5 fw-bold fs-2">{t('categories.all', { ns: 'home' })}</h1>
            <ul className="row unlist list-unstyled g-2 g-lg-3 align-items-center">
              {sortedCategories.map(category => (
                <Link
                  href={getCategoryUrl(category)}
                  key={category.id}
                >
                  <a className="col-lg-4 col-md-6 col-12 text-decoration-none text-dark">
                    <li key={category.id}
                      className="bg-light-blue p-4 p-lg-5 d-flex align-items-center justify-content-between categorypanel"
                    >
                      <h2 className="fs-4 mb-0">{category.translatedName}</h2>
                      <svg className="ms-2 flex-shrink-0"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M15.2 8H0.800049"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path d="M11.2 4L15.2 8L11.2 12"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                  </a>
                </Link>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export async function getServerSideProps ({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['categories', 'header', 'footer', 'languages', 'applications', 'home', 'routes']))
    }
  }
}
